import React from "react";

import { fmtPercent, sharePct } from "@/lib/format";
import { cn } from "@/lib/utils";
import { fmtRubExact } from "@/lib/warehouse-overview";

/** Общие классы и форматтеры ячеек таблицы «Остатков» (все четыре уровня). */
export const NUM = "whitespace-nowrap px-2 py-1 text-right tabular-nums";
/** Единицы — вторичное число: мельче и приглушённо, главное в строке — ₽. */
export const UNITS = cn(NUM, "text-xs text-muted-foreground");

/** Подсказка к «ед.»: почему это не «шт» и почему сумма условная. */
export const UNITS_TITLE =
  "базовые единицы учёта: шт, кг, л — разных товаров, складывать их между собой можно только условно";

/** ₽ или «—»: `null` — нет строки в учётном регистре, это не ноль. */
export function fmtCost(cost: number | null): string {
  return cost === null ? "—" : fmtRubExact(cost);
}

/**
 * Доля от итого по ₽: число + тонкая полоска рядом. Нет ₽ — доли нет («—»).
 * ₽ со знаком (нетто, как в 1С): у отрицательной доли смысла нет — тоже «—»,
 * сама сумма при этом показывается минусом (`fmtCost`).
 */
export function ShareCell({
  cost,
  total,
  strong,
}: {
  cost: number | null;
  total: number | null;
  strong?: boolean;
}): React.ReactElement {
  const pct = cost === null || total === null || cost < 0 ? null : sharePct(cost, total);
  return (
    <td className="px-2 py-1 pr-3">
      <div className="flex items-center gap-2">
        <span className="w-[52px] shrink-0 text-right text-xs tabular-nums text-muted-foreground">
          {fmtPercent(pct)}
        </span>
        <span className="h-1.5 flex-1 overflow-hidden rounded-full bg-slate-100">
          <span
            className={cn("block h-full rounded-full", strong ? "bg-slate-500" : "bg-slate-400")}
            style={{ width: `${pct ?? 0}%` }}
          />
        </span>
      </div>
    </td>
  );
}
